import { TextNode } from 'lexical'
import { SelectNode } from './nodes/selectNode'
import { InputNode } from './nodes/inputNode'

/**
 * @typedef {{ type: 'text'; value: string }
 *   | { type: 'input'; value: string }
 *   | { type: 'select'; value: string; options: string[]; placeholder: string }} NodeItem
 */

export function generateInsertFunction(jsonData, editorRef) {
  return () => {
    editorRef.current?.clearContent()
    jsonData.forEach(item => {
      switch (item.type) {
        case 'text':
          editorRef.current?.insertText(item.value)
          break
        case 'input':
          editorRef.current?.insertInput({ value: item.value })
          break
        case 'select':
          editorRef.current?.insertSelect({ value: item.value, options: item.options, placeholder: item.placeholder })
          break
      }
    })
  }
}

export function extractText(node) {
  if (node instanceof TextNode) return node.getTextContent()
  if (node instanceof SelectNode || node instanceof InputNode) return node.__props.value ?? ''
  if (node.getChildren) return node.getChildren().map(extractText).join('')
  return ''
}
